import { render, staticRenderFns } from "./DeSettings.vue?vue&type=template&id=431de312&scoped=true"
import script from "./DeSettings.vue?vue&type=script&lang=js"
export * from "./DeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431de312",
  null
  
)

export default component.exports